// import ga from '@ic-hosting/ich-react-redux-ga'

import wrapWithProvider from './wrap-with-provider';

// ga('UI-0000-000');

export const wrapRootElement = wrapWithProvider;


